module.exports = __webpack_public_path__ + "static/physician-transparent-d62fe5d5dbb7624d4731af76e171adc2.png";